module.exports = __webpack_public_path__ + "static/media/1001000MF.7d7777df.jpg";